import {
  DE_PACKAGE_SET,
  DE_PACKAGE_RESET,
  DE_LESSONS_PURCHASED,
} from "../actions/types"

const INITIAL_STATE = {
  dePackage: null,
  lessonsPurchased: false,
}

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case DE_PACKAGE_RESET:
      return INITIAL_STATE
    case DE_PACKAGE_SET:
      return { ...state, dePackage: action.payload }
    case DE_LESSONS_PURCHASED:
      return { ...state, lessonsPurchased: true }
    default:
      return state
  }
}
